import React from 'react';
import { Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CardProps } from '@mui/material/Card';
import palette from '@ui/palette';

export const STUDIO_CLIP_HEIGHT = 64;

const useStyles = makeStyles<{ focusBGColor: string; hideBorder?: boolean }>()(
  (theme, { focusBGColor, hideBorder }) => ({
    root: {
      height: STUDIO_CLIP_HEIGHT,
      padding: theme.spacing(0, 2, 0, 1),
      display: 'flex',
      alignItems: 'center',
      borderRadius: '5px',
      backgroundColor: hideBorder ? theme.palette.common.black : focusBGColor,
      '&:hover': {
        backgroundColor: hideBorder ? '' : palette.gray_900,
      },
    },
    clipBorder: {
      position: 'relative',
      left: '-7px',
      flex: '0 0 5px',
      height: '100%',
      background: 'transparent',
      borderRadius: '5px 0 0 5px',
    },
    clipBorderActive: {
      background: theme.palette.primary.main,
    },
  })
);

export interface StudioClipCardProps extends CardProps {
  focused: boolean;
  selected: boolean;
  hideBorder?: boolean;
}

export const StudioClipCard = (props: StudioClipCardProps) => {
  const { children, selected, focused, hideBorder, ...rest } = props;
  const focusBGColor =
    focused || selected ? palette.gray_900 : palette.gray_1000;
  const { classes, cx } = useStyles({ focusBGColor, hideBorder });
  return (
    <Card className={cx(classes.root)} {...rest}>
      <div
        className={cx(classes.clipBorder, {
          [classes.clipBorderActive]: selected && !hideBorder,
        })}
      />
      {children}
    </Card>
  );
};

export default StudioClipCard;
